/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ApplyAutoScheduleChangesInput = {
    projectId?: string | null | undefined;
    projectStartYear?: number | null | undefined;
    projectStartMonth?: number | null | undefined;
    projectStartDay?: number | null | undefined;
    projectEndYear?: number | null | undefined;
    projectEndMonth?: number | null | undefined;
    projectEndDay?: number | null | undefined;
    tasks?: Array<AutoScheduleTaskInput | null> | null | undefined;
    phases?: Array<AutoSchedulePhaseInput | null> | null | undefined;
    allocations?: Array<AutoScheduleAllocationInput | null> | null | undefined;
    projectPersons?: Array<AutoScheduleProjectPersonInputType | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type AutoScheduleTaskInput = {
    id?: string | null | undefined;
    startYear?: number | null | undefined;
    startMonth?: number | null | undefined;
    startDay?: number | null | undefined;
    deadlineYear?: number | null | undefined;
    deadlineMonth?: number | null | undefined;
    deadlineDay?: number | null | undefined;
    assignedPersons?: Array<string | null> | null | undefined;
};
export type AutoSchedulePhaseInput = {
    id?: string | null | undefined;
    startYear?: number | null | undefined;
    startMonth?: number | null | undefined;
    startDay?: number | null | undefined;
    deadlineYear?: number | null | undefined;
    deadlineMonth?: number | null | undefined;
    deadlineDay?: number | null | undefined;
};
export type AutoScheduleAllocationInput = {
    id?: string | null | undefined;
    startYear?: number | null | undefined;
    startMonth?: number | null | undefined;
    startDay?: number | null | undefined;
    endYear?: number | null | undefined;
    endMonth?: number | null | undefined;
    endDay?: number | null | undefined;
};
export type AutoScheduleProjectPersonInputType = {
    personId?: string | null | undefined;
    roleId?: string | null | undefined;
};
export type applyAutoScheduleChangesMutationVariables = {
    input: ApplyAutoScheduleChangesInput;
};
export type applyAutoScheduleChangesMutationResponse = {
    readonly applyAutoScheduleChanges: {
        readonly project: {
            readonly projectPersons: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly isContactPerson: boolean | null;
                        readonly person: {
                            readonly id: string;
                            readonly firstName: string | null;
                            readonly lastName: string | null;
                            readonly fullName: string | null;
                        } | null;
                        readonly role: {
                            readonly id: string;
                            readonly name: string | null;
                        } | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type applyAutoScheduleChangesMutation = {
    readonly response: applyAutoScheduleChangesMutationResponse;
    readonly variables: applyAutoScheduleChangesMutationVariables;
};



/*
mutation applyAutoScheduleChangesMutation(
  $input: ApplyAutoScheduleChangesInput!
) {
  applyAutoScheduleChanges(input: $input) {
    project {
      projectPersons(first: 10000) {
        edges {
          node {
            id
            isContactPerson
            person {
              id
              firstName
              lastName
              fullName
            }
            role {
              id
              name
            }
          }
        }
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ApplyAutoScheduleChangesInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10000
    }
  ],
  "concreteType": "ProjectPersonTypeConnection",
  "kind": "LinkedField",
  "name": "projectPersons",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectPersonTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectPerson",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isContactPerson",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "person",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fullName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Role",
              "kind": "LinkedField",
              "name": "role",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "projectPersons(first:10000)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "applyAutoScheduleChangesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ApplyAutoScheduleChangesPayload",
        "kind": "LinkedField",
        "name": "applyAutoScheduleChanges",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "applyAutoScheduleChangesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ApplyAutoScheduleChangesPayload",
        "kind": "LinkedField",
        "name": "applyAutoScheduleChanges",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "applyAutoScheduleChangesMutation",
    "operationKind": "mutation",
    "text": "mutation applyAutoScheduleChangesMutation(\n  $input: ApplyAutoScheduleChangesInput!\n) {\n  applyAutoScheduleChanges(input: $input) {\n    project {\n      projectPersons(first: 10000) {\n        edges {\n          node {\n            id\n            isContactPerson\n            person {\n              id\n              firstName\n              lastName\n              fullName\n            }\n            role {\n              id\n              name\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '30dd35f587024b653f52003636058448';
export default node;
